import { styled } from '@mui/material';

export const FindWrapper = styled('div')`
  display: flex;
  justify-content: space-around;
  margin-top: 10%;
`;